/* Freya catalog. Prices, variants and new product content verified against
   freyagurme.com via its read-only catalog tools on 2026-09-24.
   Prices are a snapshot, not a live synchronization. */
window.FREYA_CATEGORIES = {
  "sos": {
    "label": "Soslar",
    "color": "#B5482B"
  },
  "granola": {
    "label": "Granola",
    "color": "#7A5C34"
  },
  "zeytinyagi": {
    "label": "Zeytinyağı",
    "color": "#6F7A35"
  },
  "humus": {
    "label": "Humus",
    "color": "#687646"
  }
};
window.FREYA_PRODUCTS = [
  {
    "slug": "christmas-blend-250-g",
    "cat": "sos",
    "name": "Yılbaşı Karışımı (250 g)",
    "sizes": "250 g",
    "hue": [
      "#963B3A",
      "#3B3028"
    ],
    "short": "Gülek yaylalarının kızılcığı, portakal ve tarçınla buluşuyor.",
    "long": "Gülek yaylalarından toplanan kızılcıklarla hazırlanan Christmas Blend, hindistan cevizi şekeriyle tatlandırılır. Katkı ve koruyucu içermez.",
    "ingredients": "Kızılcık, portakal, portakal kabuğu, portakal kabuğu rendesi, tarçın, hindistan cevizi şekeri, vanilya özütü, hindistan cevizi yağı, su",
    "usage": "Hindi ve tavuk yemekleri, salata sosları, mezeler ve iç pilav",
    "tags": [
      "Katkısız"
    ],
    "stock": true,
    "variants": [
      {
        "label": "250 g",
        "price": 855,
        "available": true,
        "id": "47332103848220"
      }
    ],
    "priceFrom": 855,
    "sourceUrl": "https://www.freyagurme.com/products/christmas-blend-250-g",
    "priceCheckedAt": "2026-11-01"
  },
  {
    "slug": "ejder-meyvesi-sosu",
    "backImage": "images/products/ejder-meyvesi-sosu-arka.jpg",
    "cat": "sos",
    "name": "Ejder Meyvesi Sosu",
    "sizes": "250 g / 110 g",
    "hue": [
      "#D9598A",
      "#7A2348"
    ],
    "short": "Milas–Bodrum bahçelerimizin ejder meyvesi; ferahlatıcı, tropikal tat.",
    "long": "Milas–Bodrum bahçelerimizden topladığımız ejder meyvesinden (pitaya) hazırlanan, hafif tatlı ve tropikal aromalı bir sos. Markamızın başladığı meyve; smoothie'lere, tatlılara, yoğurda ve kahvaltı tabaklarına canlı bir renk ve ferahlık katar.",
    "ingredients": "Pitaya (ejder meyvesi), hindistan cevizi şekeri, elma pektini, limon, hindistan cevizi yağı, vanilya, tuz",
    "usage": "Smoothie, yoğurt, tatlı ve kahvaltı tabağı",
    "tags": [
      "Vegan",
      "Katkısız",
      "Glutensiz"
    ],
    "stock": true,
    "variants": [
      {
        "label": "250 g",
        "price": 600,
        "available": true,
        "id": "50270746738972"
      },
      {
        "label": "110 g",
        "price": 300,
        "available": true,
        "id": "50270746771740"
      }
    ],
    "priceFrom": 300,
    "sourceUrl": "https://www.freyagurme.com/products/ejder-meyvesi-sosu",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "pancar-havlican-sosu",
    "backImage": "images/products/pancar-havlican-sosu-arka.jpg",
    "cat": "sos",
    "name": "Pancar & Havlıcan Sosu",
    "sizes": "250 g / 110 g",
    "hue": [
      "#A8385C",
      "#4E1A2E"
    ],
    "short": "Afyon pancarının doğal tatlılığı, havlıcanın baharatlı aromasıyla buluşuyor.",
    "long": "Afyon'dan tedarik ettiğimiz pancarların doğal tatlılığını havlıcanın baharatlı, ısıtan aromasıyla birleştiren özgün bir sos. Özellikle salatalar, peynir tabakları ve et yemekleri için mükemmel bir tamamlayıcıdır.",
    "ingredients": "Pancar, hindistan cevizi şekeri, portakal, limon, elma, portakal kabuğu, elma pektini, elma sirkesi, havlıcan, hindistan cevizi yağı, tuz",
    "usage": "Et yemekleri, peynir tabağı, kahvaltı",
    "tags": [
      "Vegan",
      "Katkısız",
      "Glutensiz"
    ],
    "stock": true,
    "variants": [
      {
        "label": "250 g",
        "price": 555,
        "available": true,
        "id": "50270832328988"
      },
      {
        "label": "110 g",
        "price": 278,
        "available": true,
        "id": "50270832361756"
      }
    ],
    "priceFrom": 278,
    "sourceUrl": "https://www.freyagurme.com/products/pancar-havlican-sosu",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "cilek-jalapeno-sosu",
    "backImage": "images/products/cilek-jalapeno-sosu-arka.jpg",
    "cat": "sos",
    "name": "Çilek & Jalepeno Sosu",
    "sizes": "250 g / 110 g",
    "hue": [
      "#CB424B",
      "#7E2330"
    ],
    "short": "Silifke çileği ile Ege jalapeñosu; tatlı ile ateşli arasında cesur bir denge.",
    "long": "Silifke'deki tarlalardan toplattığımız çilekler ve Ege Ovaları'ndan getirttiğimiz jalapeño biberleriyle hazırlanır. Çileğin tatlı aromasını jalapeñonun ateşli karakteriyle buluşturur; peynir tabaklarıyla, sandviçlerle ve ızgara etlerle çarpıcı bir tezat oluşturur. 100 gramında 78 g meyve bulunur.",
    "ingredients": "Çilek, jalapeño biber, hindistan cevizi şekeri, elma, zencefil turşusu, limon, limon kabuğu, hindistan cevizi yağı, tuz",
    "usage": "Peynir tabağı, sandviç, ızgara et",
    "tags": [
      "Vegan",
      "Katkısız",
      "%78 meyve"
    ],
    "stock": true,
    "variants": [
      {
        "label": "250 g",
        "price": 585,
        "available": true,
        "id": "50270733336860"
      },
      {
        "label": "110 g",
        "price": 293,
        "available": true,
        "id": "50270733369628"
      }
    ],
    "priceFrom": 293,
    "sourceUrl": "https://www.freyagurme.com/products/cilek-jalapeno-sos",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "zencefil-acili-armut-sosu",
    "backImage": "images/products/zencefil-acili-armut-sosu-arka.jpg",
    "cat": "sos",
    "name": "Zencefil & Acılı Armut Sosu",
    "sizes": "250 g / 110 g",
    "hue": [
      "#CD9430",
      "#8A5A18"
    ],
    "short": "Ankara Deveci armudu ile Muğla zencefili; tatlı, ferah ve hafif baharatlı.",
    "long": "Ankara'dan temin ettiğimiz Deveci armutları, Muğla seralarından gelen taze zencefiller ve İçel seralarının biberleriyle hazırlanır. Armudun tatlı aromasını zencefilin keskin, ısıtan karakteri ve hafif acı notalarla dengeler. (Sos içindeki ipliksi yapılar zencefile aittir.)",
    "ingredients": "Zencefil, armut, hindistan cevizi şekeri, hindistan cevizi yağı, elma, elma pektini, limon, limon kabuğu, kırmızı acı biber, tuz",
    "usage": "Izgara et, salata, peynir tabağı",
    "tags": [
      "Vegan",
      "Katkısız",
      "Glutensiz"
    ],
    "stock": true,
    "variants": [
      {
        "label": "250 g",
        "price": 595,
        "available": true,
        "id": "50270859886876"
      },
      {
        "label": "110 g",
        "price": 298,
        "available": true,
        "id": "50270859919644"
      }
    ],
    "priceFrom": 298,
    "sourceUrl": "https://www.freyagurme.com/products/zencefil-ve-acili-armut-sosu",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "baharatli-balkabagi-sosu",
    "backImage": "images/products/baharatli-balkabagi-sosu-arka.jpg",
    "cat": "sos",
    "name": "Baharatlı Balkabağı Sosu",
    "sizes": "250 g / 110 g",
    "hue": [
      "#C46A22",
      "#8A4416"
    ],
    "short": "Balkabağı ve sıcak baharatların sonbahara özel buluşması.",
    "long": "Balkabağının kadifemsi dokusunu tarçın ve sıcak baharatlarla buluşturan, sonbahara özel mevsimsel bir sos. Kahvaltıda ve tatlılarda nostaljik bir sıcaklık bırakır.",
    "ingredients": "Balkabağı, hindistan cevizi şekeri, elma pektini, limon, hindistan cevizi yağı, tarçın, baharatlar, tuz",
    "usage": "Kahvaltı, tatlı, fırın ürünleri",
    "tags": [
      "Vegan",
      "Katkısız",
      "Glutensiz"
    ],
    "stock": false,
    "variants": [
      {
        "label": "250 g",
        "price": 560,
        "available": false,
        "id": "50269389259036"
      },
      {
        "label": "110 g",
        "price": 280,
        "available": false,
        "id": "50269389226268"
      }
    ],
    "priceFrom": 280,
    "sourceUrl": "https://www.freyagurme.com/products/kopya-baharatli-balkabagi",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "maviyemis-lavanta-sosu",
    "backImage": "images/products/maviyemis-lavanta-sosu-arka.jpg",
    "cat": "sos",
    "name": "Maviyemiş & Lavanta Sosu",
    "sizes": "250 g / 110 g",
    "hue": [
      "#5E5B8E",
      "#34315E"
    ],
    "short": "Adana seralarımızdan maviyemiş ile Ege lavantasının zarif, çiçeksi buluşması.",
    "long": "Adana'daki seralarımızdan tedarik edilen taze maviyemişler ve Ege'nin verimli tarlalarından özenle toplanan lavantalarla hazırlanır. Maviyemişin tatlı-mayhoş notalarını lavantanın çiçeksi, sakinleştirici aromasıyla buluşturur; peynir tabaklarına ve tatlılara zarif bir dokunuş katar. 100 gramında 78 g meyve bulunur.",
    "ingredients": "Maviyemiş (yaban mersini), lavanta, hindistan cevizi şekeri, elma pektini, limon, hindistan cevizi yağı, tuz",
    "usage": "Peynir tabağı, tatlı, kahvaltı",
    "tags": [
      "Vegan",
      "Katkısız",
      "%78 meyve"
    ],
    "stock": true,
    "variants": [
      {
        "label": "250 g",
        "price": 600,
        "available": true,
        "id": "50270758207772"
      },
      {
        "label": "110 g",
        "price": 300,
        "available": false,
        "id": "50270758240540"
      }
    ],
    "priceFrom": 300,
    "sourceUrl": "https://www.freyagurme.com/products/maviyemis-lavanta-sos",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "carkifelek-sosu",
    "backImage": "images/products/carkifelek-sosu-arka.jpg",
    "cat": "sos",
    "name": "Çarkıfelek Sosu",
    "sizes": "250 g / 110 g",
    "hue": [
      "#D89A2E",
      "#A85E1C"
    ],
    "short": "Antalya'dan çarkıfelek meyvesi; egzotik, tatlı-ekşi bir lezzet patlaması.",
    "long": "Antalya'daki üreticilerden temin edilen çarkıfelek (passion fruit) meyvesinden hazırlanır. Tatlı-ekşi profiliyle egzotik bir lezzet patlaması sunar ve taze meyvenin tropikal aromasını korur; 100 gramında 79 g meyve bulunur. Salatalar, tatlılar ve peynir tabakları için idealdir.",
    "ingredients": "Çarkıfelek (passion fruit), hindistan cevizi şekeri, elma pektini, limon, hindistan cevizi yağı, tuz",
    "usage": "Salata, tatlı, peynir tabağı",
    "tags": [
      "Vegan",
      "Katkısız",
      "%79 meyve"
    ],
    "stock": true,
    "variants": [
      {
        "label": "250 g",
        "price": 625,
        "available": true,
        "id": "50270719213852"
      },
      {
        "label": "110 g",
        "price": 313,
        "available": true,
        "id": "50270719246620"
      }
    ],
    "priceFrom": 313,
    "sourceUrl": "https://www.freyagurme.com/products/carkifelek-sosu",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "visne-iskin-otu-sosu",
    "backImage": "images/products/visne-iskin-otu-sosu-arka.jpg",
    "cat": "sos",
    "name": "Vişne & Işkın Otu Sosu",
    "sizes": "250 g / 110 g",
    "hue": [
      "#A8324A",
      "#5E1A2C"
    ],
    "short": "Vişnenin mayhoş tadı, Mardin ışkın otunun ferah ekşiliğiyle buluşuyor.",
    "long": "Yöre bahçelerinin vişneleri, Mardin yöresinden gelen ışkın otuyla buluşur. Vişnenin mayhoş tadı ile ışkın otunun hafif ekşi ve ferahlatıcı aromasını dengeleyen özgün bir sos; tatlılar, peynir tabakları ve salatalar için idealdir. 100 gramında 75 g meyve bulunur.",
    "ingredients": "Vişne, ışkın otu, elma, hindistan cevizi şekeri, elma pektini, limon, limon kabuğu, hindistan cevizi yağı, yıldız anason, tuz",
    "usage": "Tatlı, peynir tabağı, salata",
    "tags": [
      "Vegan",
      "Katkısız",
      "%75 meyve"
    ],
    "stock": true,
    "variants": [
      {
        "label": "250 g",
        "price": 640,
        "available": true,
        "id": "50270843437340"
      },
      {
        "label": "110 g",
        "price": 320,
        "available": true,
        "id": "50270843470108"
      }
    ],
    "priceFrom": 320,
    "sourceUrl": "https://www.freyagurme.com/products/visne-ve-iskin-otu-sosu",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "visne-salsa-sosu",
    "backImage": "images/products/visne-salsa-sosu-arka.jpg",
    "cat": "sos",
    "name": "Vişne & Salsa Sosu",
    "sizes": "250 g",
    "hue": [
      "#B23A2E",
      "#6E2018"
    ],
    "short": "Vişnenin meyvemsi tatlılığı ile salsanın canlı, baharatlı karakteri.",
    "long": "Vişnenin meyvemsi tatlılığını salsanın canlı, baharatlı karakteriyle birleştiren iddialı bir sos. Atıştırmalıklarla, nachos ve ızgaralarla şenlikli bir uyum yakalar.",
    "ingredients": "Vişne, domates, biber, soğan, hindistan cevizi şekeri, elma pektini, limon, baharatlar, tuz",
    "usage": "Nachos, atıştırmalık, ızgara",
    "tags": [
      "Vegan",
      "Katkısız"
    ],
    "stock": true,
    "variants": [
      {
        "label": "250 g",
        "price": 650,
        "available": true,
        "id": "50253443629340"
      }
    ],
    "price": 650,
    "sourceUrl": "https://www.freyagurme.com/products/visne-salsa-sosu",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "incir-balsamik-sos",
    "backImage": "images/products/incir-balsamik-sos-arka.png",
    "cat": "sos",
    "name": "İncir Balsamik Sos",
    "sizes": "250 g",
    "hue": [
      "#6E5A3A",
      "#3C2E1E"
    ],
    "short": "Olgun incirin yoğunluğu ile balsamiğin asil ekşiliği.",
    "long": "Olgun incirin yoğun tatlılığını balsamik sirkenin asil ekşiliğiyle dengeleyen sofistike bir sos. Peynir tabaklarının, ızgara etlerin ve salataların vazgeçilmez eşlikçisi.",
    "ingredients": "İncir, balsamik sirke, hindistan cevizi şekeri, elma pektini, limon, tuz",
    "usage": "Peynir tabağı, salata, ızgara et",
    "tags": [
      "Vegan",
      "Katkısız"
    ],
    "stock": true,
    "variants": [
      {
        "label": "250 g",
        "price": 615,
        "available": true,
        "id": "52916785053980"
      }
    ],
    "price": 615,
    "sourceUrl": "https://www.freyagurme.com/products/i%CC%87ncir-balsamik-sos",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "mini-sos-kutusu",
    "cat": "sos",
    "name": "Mini Sos Kutusu",
    "sizes": "4’lü kutu",
    "hue": [
      "#C28A2E",
      "#7A4F12"
    ],
    "short": "Freya soslarını keşfetmenin en zarif yolu; mini boylardan oluşan set.",
    "long": "Freya'nın en sevilen soslarını mini boylarda bir araya getiren keşif seti. Hem kendinize hem de sevdiklerinize; tatları denemenin ya da hediye etmenin en zarif yolu.",
    "ingredients": "Seçili Freya sosları (mini boy)",
    "usage": "Keşif & hediye",
    "tags": [
      "Hediyelik",
      "Keşif seti"
    ],
    "stock": true,
    "variants": [
      {
        "label": "4’lü kutu",
        "price": 735,
        "available": true,
        "id": "53336306123036"
      }
    ],
    "price": 735,
    "sourceUrl": "https://www.freyagurme.com/products/mini-sos-kutusu",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "hindistan-cevizi-granola",
    "backImage": "images/products/hindistan-cevizi-granola-arka.jpg",
    "cat": "granola",
    "name": "Hindistan Cevizi Granola",
    "sizes": "300 g",
    "hue": [
      "#C9B58E",
      "#8E754C"
    ],
    "short": "Türkiye'de ilk kez yulaf yerine hindistan cevizi; hafif tatlı, besleyici.",
    "long": "Türkiye'de ilk defa yulaf yerine hindistan cevizi kullanılarak hazırlanmıştır. Hafif tatlı hindistan cevizi aromasıyla; yoğurt ve meyveyle ya da tek başına besleyici bir kahvaltı ve atıştırmalık alternatifi sunar.",
    "nutrition": "100 g: 567 kcal · Yağ 42,4 g · Karbonhidrat 33,8 g · Lif 7,7 g · Protein 8,6 g",
    "ingredients": "Kuru hindistan cevizi, elma, ceviz, yer fıstığı, kabak çekirdeği, keten tohumu, hindistan cevizi yağı, chia tohumu, tarçın",
    "usage": "Yoğurt, süt, meyve ile veya tek başına",
    "tags": [
      "Vegan",
      "Glutensiz",
      "Yulafsız"
    ],
    "stock": true,
    "variants": [
      {
        "label": "300 g",
        "price": 600,
        "available": true,
        "id": "50270869258524"
      }
    ],
    "price": 600,
    "sourceUrl": "https://www.freyagurme.com/products/hindistan-cevizi-granola",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "cikolatali-granola",
    "backImage": "images/products/cikolatali-granola-arka.jpg",
    "cat": "granola",
    "name": "Çikolatalı Granola",
    "sizes": "300 g",
    "hue": [
      "#7A4B2E",
      "#4A2C18"
    ],
    "short": "Hindistan cevizi tabanlı granolanın çikolatayla buluşan hâli.",
    "long": "Yulafsız hindistan cevizi granolasını gerçek çikolatanın yoğunluğuyla buluşturan keyifli bir tarif. Tatlı krizlerine sağlıklı bir yanıt; yoğurt ve sütle mükemmel uyum.",
    "ingredients": "Kuru hindistan cevizi, kakao/çikolata, elma, ceviz, kabak çekirdeği, keten tohumu, hindistan cevizi yağı, chia tohumu",
    "usage": "Yoğurt, süt, atıştırmalık",
    "tags": [
      "Vegan",
      "Glutensiz",
      "Yulafsız"
    ],
    "stock": true,
    "variants": [
      {
        "label": "300 g",
        "price": 600,
        "available": true,
        "id": "51067963900188"
      }
    ],
    "price": 600,
    "sourceUrl": "https://www.freyagurme.com/products/cikolatali-granola",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "kuru-meyveli-granola",
    "backImage": "images/products/kuru-meyveli-granola-arka.jpg",
    "cat": "granola",
    "name": "Kuru Meyveli Granola",
    "sizes": "300 g",
    "hue": [
      "#B5793E",
      "#7A4E22"
    ],
    "short": "Hindistan cevizi granolasına kuru meyvelerin doğal tatlılığı eşlik ediyor.",
    "long": "Yulafsız hindistan cevizi granolasını çeşitli kuru meyvelerin doğal tatlılığıyla zenginleştiren dengeli bir karışım. Gün boyu enerji veren, lifli ve doyurucu bir seçim.",
    "ingredients": "Kuru hindistan cevizi, kuru meyveler, elma, ceviz, kabak çekirdeği, keten tohumu, hindistan cevizi yağı, chia tohumu, tarçın",
    "usage": "Yoğurt, süt, meyve ile",
    "tags": [
      "Vegan",
      "Glutensiz",
      "Yulafsız"
    ],
    "stock": true,
    "variants": [
      {
        "label": "300 g",
        "price": 600,
        "available": true,
        "id": "51067965833500"
      }
    ],
    "price": 600,
    "sourceUrl": "https://www.freyagurme.com/products/kuru-meyveli-granola",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "matcha-granola",
    "backImage": "images/products/matcha-granola-arka.jpg",
    "cat": "granola",
    "name": "Matcha Granola",
    "sizes": "300 g",
    "hue": [
      "#7E9450",
      "#566734"
    ],
    "short": "Ferahlatıcı matcha aroması, hindistan cevizinin hafif tropikal dokusuyla.",
    "long": "Türkiye'de ilk defa yulaf yerine hindistan cevizi kullanılarak hazırlanmıştır. Ferahlatıcı matcha aroması, hindistan cevizinin hafif tropikal dokusuyla buluşur; kinoa, kabak çekirdeği ve kuru kızılcıkla zenginleşir. Yoğurt, süt ve taze meyveyle ya da tek başına tüketebilirsiniz.",
    "nutrition": "100 g: 496 kcal · Yağ 32,6 g · Karbonhidrat 36,8 g · Lif 14,6 g · Protein 6,6 g",
    "ingredients": "Kuru hindistan cevizi, matcha, kinoa, kuru kızılcık, vanilya, elma, lime & limon kabuğu, kabak çekirdeği içi, portakal & limon suyu, hindistan cevizi şekeri, hindistan cevizi yağı",
    "usage": "Yoğurt, süt, smoothie bowl",
    "tags": [
      "Vegan",
      "Glutensiz",
      "Yulafsız"
    ],
    "stock": true,
    "variants": [
      {
        "label": "300 g",
        "price": 625,
        "available": true,
        "id": "52711609762076"
      }
    ],
    "price": 625,
    "sourceUrl": "https://www.freyagurme.com/products/matcha-granola",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "ubeli-mor-granola",
    "backImage": "images/products/ubeli-mor-granola-arka.png",
    "cat": "granola",
    "name": "Ubeli Mor Granola",
    "short": "Ube ve hindistan cevizinin mor renkli, çıtır buluşması.",
    "long": "Yulaf yerine hindistan ceviziyle hazırlanan Ubeli Mor Granola, ubenin kendine özgü rengini ve aromasını kahvaltıya taşıyor. Yoğurt ve meyvelerle ya da sade olarak tüketebilirsiniz.",
    "ingredients": "Kurutulmuş hindistan cevizi, karabuğday, elma, hindistan cevizi yağı, çikolata, badem, ube, maviyemiş kurusu, vanilya özütü",
    "nutrition": "100 g: Enerji 522 kcal · Yağ 29,4 g · Doymuş yağ 24,07 g · Karbonhidrat 52,6 g · Şeker 34,5 g · Diyet lif 6,9 g · Protein 8,3 g · Tuz 0,08 g",
    "usage": "Yoğurt, meyve ile veya sade",
    "tags": [
      "Yeni",
      "Yulafsız"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/files/purple_granola.png?v=1784883590",
    "variants": [
      {
        "label": "300 g",
        "price": 650,
        "available": true,
        "id": "54342520701212"
      }
    ],
    "price": 650,
    "stock": true,
    "sizes": "300 g",
    "sourceUrl": "https://www.freyagurme.com/products/ubeli-mor-granola",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "klasik-humus",
    "cat": "humus",
    "name": "Klasik Humus",
    "short": "Nohut, taş değirmen tahini ve sızma zeytinyağıyla klasik humus.",
    "long": "Özenle seçilen nohutlar, taş değirmende çekilmiş susamdan elde edilen tahin ve sızma zeytinyağıyla buluşuyor. Limon ve sarımsakla dengelenen kadife kıvamlı humusu çıtır ekmek veya taze sebze çubuklarıyla servis edebilirsiniz.",
    "ingredients": "Nohut, tahin (susam), sızma zeytinyağı, limon suyu, sarımsak, kimyon, tuz",
    "usage": "Kahvaltı, meze tabağı, sandviç; çıtır ekmek veya sebze çubuklarıyla",
    "tags": [
      "Yeni",
      "El yapımı",
      "Katkısız"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/files/klasik-humus.jpg?v=1783169161",
    "variants": [
      {
        "label": "Standart",
        "price": 650,
        "available": true,
        "id": "54272847708444"
      }
    ],
    "price": 650,
    "stock": true,
    "sizes": "",
    "sourceUrl": "https://www.freyagurme.com/products/klasik-humus",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "jalapeno-biberli-humus",
    "cat": "humus",
    "name": "Jalapeno Biberli Humus",
    "short": "Kremamsı humus, taze jalapeño biberinin ferah acısıyla.",
    "long": "Ege Ovaları’ndan gelen jalapeño biberleri, özenle pişirilen nohut ve taş değirmen tahiniyle buluşuyor. Acısını taze jalapeño’dan alan bu humus; sandviçlere, ızgara sebzelere ve atıştırmalık tabaklarına eşlik eder.",
    "ingredients": "Nohut, tahin (susam), jalapeño biber, sızma zeytinyağı, limon suyu, sarımsak, kimyon, tuz",
    "usage": "Sandviç, ızgara sebze, tortilla cipsi ve nachos",
    "tags": [
      "Yeni",
      "El yapımı",
      "Katkısız"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/files/jalapeno-biberli-humus.jpg?v=1783169196",
    "variants": [
      {
        "label": "Standart",
        "price": 675,
        "available": true,
        "id": "54272849510684"
      }
    ],
    "price": 675,
    "stock": true,
    "sizes": "",
    "sourceUrl": "https://www.freyagurme.com/products/jalapeno-biberli-humus",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "pancarli-humus",
    "cat": "humus",
    "name": "Pancarlı Humus",
    "short": "Fırınlanmış pancarın doğal tatlılığı, nohut ve tahinle.",
    "long": "Afyon’dan tedarik edilen pancarlar fırında yavaşça pişirilip nohut ve tahinle bir araya geliyor. Rengini pancardan alan bu humus, meze tabaklarına ve brunch sofralarına renk katıyor.",
    "ingredients": "Nohut, pancar, tahin (susam), sızma zeytinyağı, limon suyu, sarımsak, kimyon, tuz",
    "usage": "Salata, meze tabağı, brunch ve peynir tabağı",
    "tags": [
      "Yeni",
      "El yapımı",
      "Katkısız"
    ],
    "image": "https://cdn.shopify.com/s/files/1/0753/6610/5372/files/pancarli-humus.jpg?v=1783169267",
    "variants": [
      {
        "label": "Standart",
        "price": 670,
        "available": true,
        "id": "54272852558108"
      }
    ],
    "price": 670,
    "stock": true,
    "sizes": "",
    "sourceUrl": "https://www.freyagurme.com/products/pancarli-humus",
    "priceCheckedAt": "2026-09-24"
  },
  {
    "slug": "aci-biberli-zeytinyagi",
    "backImage": "images/products/aci-biberli-zeytinyagi-arka.png",
    "cat": "zeytinyagi",
    "name": "Acı Biberli Zeytinyağı",
    "sizes": "500 ml / 250 ml",
    "hue": [
      "#8E8B3D",
      "#5E5A22"
    ],
    "short": "İmamoğlu bahçemizin soğuk sıkım zeytinyağı, Urfa & Hatay biberiyle demlendi.",
    "long": "İmamoğlu, Adana'daki bahçemizden hasat edilen zeytinlerin soğuk sıkım natürel zeytinyağı; kurutulmuş acı Urfa biberi ve Hatay biberi ile demlenip şişelenmeden önce üç ay fıçıda dinlendirilir. Yemeklerinize hafif acı ama derin, aromatik bir lezzet katar.",
    "ingredients": "Soğuk sıkım natürel zeytinyağı, acı biber (Urfa & Hatay)",
    "usage": "Salata, makarna, ızgara et, marinasyon; kahvaltıda peynir & ekmekle",
    "tags": [
      "Doğal",
      "Soğuk sıkım",
      "3 ay fıçıda"
    ],
    "stock": true,
    "variants": [
      {
        "label": "500 ml",
        "price": 1100,
        "available": true,
        "id": "50273259815196"
      },
      {
        "label": "250 ml",
        "price": 600,
        "available": false,
        "id": "50273259847964"
      }
    ],
    "priceFrom": 600,
    "sourceUrl": "https://www.freyagurme.com/products/aci-biberli-zeytinyagi",
    "priceCheckedAt": "2026-09-24"
  }
];

/* ── Çiftlikten Sofraya — iz sürülebilir tedarik ──────────────────
   Markanın en güçlü farkı: her hammaddenin gerçek yöresi. Tümü
   freyagurme.com ürün sayfalarından doğrulanmıştır. `x,y` değerleri
   Türkiye haritası SVG'sinde (0–1000 / 0–460 viewBox) konumdur. */
window.FREYA_ORIGINS = [
  { region: "Milas – Bodrum", item: "Ejder meyvesi (pitaya)", note: "Markanın başladığı meyve; kendi bahçelerimiz", x: 145, y: 322 },
  { region: "Silifke", item: "Çilek", note: "Çilek & Jalepeno sosu için", x: 425, y: 348 },
  { region: "Ege Ovaları", item: "Jalapeño & lavanta", note: "Verimli Ege tarlaları", x: 155, y: 280 },
  { region: "Afyon", item: "Pancar", note: "Pancar & Havlıcan sosu için", x: 245, y: 270 },
  { region: "Ankara", item: "Deveci armudu", note: "Zencefil & Acılı Armut sosu", x: 360, y: 235 },
  { region: "Muğla", item: "Taze zencefil", note: "Sera üretimi", x: 180, y: 320 },
  { region: "Antalya", item: "Çarkıfelek (passion fruit)", note: "Yerel üreticiler", x: 280, y: 335 },
  { region: "Adana", item: "Maviyemiş & zeytin", note: "Seralarımız + İmamoğlu zeytinliği", x: 490, y: 335 },
  { region: "Hatay & Urfa", item: "Acı biber", note: "Zeytinyağını demlemek için", x: 600, y: 340 },
  { region: "Mardin", item: "Işkın otu", note: "Vişne & Işkın Otu sosu için", x: 740, y: 322 },
];

/* Birkaç çarpıcı sayı — sosların gerçek meyve oranı ve süreçten. */
window.FREYA_PROOF = [
  { value: "%79", label: "Çarkıfelek sosunda meyve oranı", sub: "100 g'da 79 g meyve" },
  { value: "10+", label: "Türkiye'den özenle seçilen yöre", sub: "İz sürülebilir tedarik" },
  { value: "3 ay", label: "Zeytinyağı fıçıda dinlenir", sub: "Soğuk sıkım, Adana" },
  { value: "0", label: "Katkı & koruyucu", sub: "%100 doğal, vegan" },
];
